import React, { useState, useEffect } from 'react';
import { Card, Col, Container, Row, Table } from 'react-bootstrap';
import BreadCrumb from 'Common/BreadCrumb';
import Swal from 'sweetalert2'; // Import SweetAlert2
import axios from 'axios'; // Import axios

interface MigrationFile {
  name: string;
  className: string;
  fullPath: string;
  size: number;
  created: string;
  modified: string;
  migrated: string;
}

const Development = () => {
  document.title = 'Migration Files | CITY SERVICE';


  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [tableData, setTableData] = useState<MigrationFile[]>([]); // Migration files data
  const [responseInfo, setResponseInfo] = useState<{ count: number; executed: number; path: string } | null>(null);





  const fetchDevelopment = async () => {
    setIsLoading(true); // Start loading
    Swal.fire({
      title: 'Loading...',
      html: 'Please wait while we fetch the data.',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const token = localStorage.getItem('authToken'); // Retrieve token from localStorage
      if (!token) {
        throw new Error('Authentication token is missing. Please log in again.');
      }

      const response = await axios.get('/cli/migrations', {
        headers: {
          Authorization: `Bearer ${token}`, // Add token to Authorization header
        },
      });

      setTableData(response.data.data || []); // Update table data with API response
      setResponseInfo({
        count: response.data.count || 0,
        executed: response.data.executed || 0,
        path: response.data.path || ''
      });
      
      Swal.fire({
        icon: 'success',
        title: 'Migration Files Loaded',
        showConfirmButton: false,
        timer: 1000, // Smooth transition after loading
      });
    } catch (error) {
      Swal.fire(
        'Error',
        (axios.isAxiosError(error) && error.response?.data?.message) || (error instanceof Error && error.message) || 'Failed to fetch migration files',
        'error'
      );
    } finally {
      setIsLoading(false); // End loading
    }
  };



  useEffect(() => {
    fetchDevelopment(); // Fetch development data on component mount
  }, []); // Fetch development data on component mount

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb pageTitle="Migration Files" title="Development" />

          {responseInfo && (
            <Row className="mb-3">
              <Col lg={12}>
                <Card className="border-0 shadow-sm">
                  <Card.Body className="py-2">
                    <div className="d-flex justify-content-between align-items-center text-muted small">
                      <span><strong>Total:</strong> {responseInfo.count} files</span>
                      <span><strong>Executed:</strong> {responseInfo.executed} migrations</span>
                      <span><strong>Path:</strong> {responseInfo.path}</span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          <Row>
            <Col lg={12}>
              <Card>
                <Card.Header>
                  <h5 className="card-title mb-0">Migration Files</h5>
                </Card.Header>
                <Card.Body>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Migration Name</th>
                        <th>Class Name</th>
                        <th>Size</th>
                        <th>Status</th>
                        <th>Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(tableData) && tableData.length > 0 ? (
                        tableData.map((migration, index) => (
                          <tr key={migration.name}>
                            <td>{index + 1}</td>
                            <td>
                              <div className="d-flex flex-column">
                                <span className="fw-medium">{migration.name}</span>
                                <small className="text-muted">{migration.fullPath}</small>
                              </div>
                            </td>
                            <td>{migration.className}</td>
                            <td>{(migration.size / 1024).toFixed(2)} KB</td>
                            <td>
                              <span className={`badge ${migration.migrated === 'yes' ? 'bg-success' : 'bg-warning'}`}>
                                {migration.migrated === 'yes' ? 'Migrated' : 'Pending'}
                              </span>
                            </td>
                            <td>{new Date(migration.created).toLocaleDateString()}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center">
                            No migration files available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>


      </div>
    </React.Fragment>
  );
};

export default Development;
